/* tslint:disable */
/* eslint-disable */
export enum EnumRequestCompanies {
	Agil = 'Agil',
	EXPERTIA = 'Expertia'
}
